import axios from "axios";
import { axiosBaseUrl } from "../constants";
import { createStandaloneToast, UseToastOptions } from "@chakra-ui/react";
const { toast } = createStandaloneToast();

export const DEFAULT_ERROR_TOAST: UseToastOptions = {
  title: "Error Occured",
  status: "error",
  duration: 5000,
  isClosable: true,
};

const UNAUTHORIZED_STATUS_CODE = 401;

const axiosClient = axios.create({
  baseURL: axiosBaseUrl + "/api",
  withCredentials: true,
});

axiosClient.interceptors.response.use(
  (payload) => {
    const data = payload.data;
    if (data.responseCode !== 200) {
      toast({
        ...DEFAULT_ERROR_TOAST,
        description: data.responseMessage || "Something went wrong.",
      });

      return Promise.reject({
        status: data.responseCode,
        message: data.responseMessage,
      });
    }

    return data.responseData;
  },
  (error) => {
    if (error.status === UNAUTHORIZED_STATUS_CODE) {
      return (window.location.href = "/admin");
    }
    toast({
      ...DEFAULT_ERROR_TOAST,
      description:
        error.response?.data?.message || error.message || "Unexpected error.",
    });

    return Promise.reject(error);
  }
);

export default axiosClient;
